/** Estado de interfaz, no contrato con el servidor (ese es `DecisionCola`). */
export type GestoEnCurso = {
  tipo: 'tachon' | 'multiple'
  casillas: string[]
  /**
   * `true`: los números prenden y apagan tachadas; `false`: el número es la respuesta. `Enter` cruza.
   * En una doble marcación no hay segunda mitad: dos marcas vivas son un dato perdido (manual p. 76).
   */
  senalando: boolean
} | null

export function abrirGesto(tipo: 'tachon' | 'multiple'): NonNullable<GestoEnCurso> {
  return {tipo, casillas: [], senalando: true}
}

export function alternarCasilla(gesto: NonNullable<GestoEnCurso>, valor: string): GestoEnCurso {
  return {
    ...gesto,
    casillas: gesto.casillas.includes(valor)
      ? gesto.casillas.filter((casilla) => casilla !== valor)
      : [...gesto.casillas, valor],
  }
}

/** Sin gesto en curso un número siempre es una respuesta; teclado y chips comparten esta definición. */
export function senalando(gesto: GestoEnCurso): boolean {
  return gesto !== null && (gesto.tipo === 'multiple' || gesto.senalando)
}

export function AvisoGesto({mensaje, testId}: {mensaje: string; testId: string}) {
  return (
    <p className="notice-amber rounded-md px-3 py-2 text-xs" data-testid={testId}>
      {mensaje}
    </p>
  )
}
